<template>
  <div class="export-pdf-container">
    <div class="box-header">
      <p class="title">
        {{
          uniCategoryRating.criterion_category
            ? uniCategoryRating.criterion_category.name
            : ""
        }}
      </p>
    </div>
    <div class="content">
      <table class="common-table">
        <tr class="tr-heading">
          <th>No.</th>
          <th>Criterion & Indicators</th>
          <th>Weight</th>
          <th>Minimum rating level</th>
          <th>Real data</th>
          <th>Score</th>
          <th>Awarded stars</th>
        </tr>
        <tr class="tr-main">
          <td>{{ orderNumber }}</td>
          <td>
            {{
              uniCategoryRating.criterion_category
                ? uniCategoryRating.criterion_category.name
                : ""
            }}
          </td>
          <td>{{ uniCategoryRating.weight | formatNumber }}</td>
          <td></td>
          <td></td>
          <td>{{ uniCategoryRating.score | formatNumber }}</td>
          <td>
            <p v-if="!uniCategoryRating.star || uniCategoryRating.star == '0'">
              N/A
            </p>
            <img
              v-else
              class="table-star-big"
              style="max-width: 150px"
              alt=""
              :src="
                `img/icon-rating/${getCategoryStarImg(
                  universityInfo.university_type_id === 1
                    ? 'research'
                    : 'applied',
                  uniCategoryRating.star
                )}`
              "
            />
          </td>
        </tr>
        <template
          v-for="(criteria, criteriaIndex) in uniCategoryRating.criteria"
        >
          <tr
            :key="'top-page-break-' + criteriaIndex"
            class="top-page-break page-break-pdf"
            v-if="
              (criteriaIndex === 7 ||
                criteriaIndex === 14 ||
                criteriaIndex === 22) &&
                uniCategoryRating.criteria.length !== 8
            "
          ></tr>
          <tr class="tr-sub" :key="'tr-sub' + criteriaIndex">
            <td class="order-number">
              {{ orderNumber }}.{{ criteriaIndex + 1 }}
            </td>
            <td>
              <p class="table-text-big">
                {{ criteria.criterion ? criteria.criterion.name : "" }}
              </p>
              <p class="table-text-small">
                {{ criteria.criterion ? criteria.criterion.description : "" }}
              </p>
            </td>
            <td>{{ criteria.weight | formatNumber }}</td>
            <td>
              {{ criteria.min_point }}-{{ criteria.benchmark
              }}{{ criteria.unit }}
            </td>
            <td>{{ criteria.achievement }}</td>
            <td>{{ criteria.score | formatNumber }}</td>
            <td>
              <p v-if="!criteria.star || criteria.star == '0'">
                N/A
              </p>
              <img
                v-else
                class="table-star-small"
                style="max-width: 150px"
                alt=""
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    universityInfo.university_type_id === 1
                      ? 'research'
                      : 'applied',
                    criteria.star
                  )}`
                "
              />
            </td>
          </tr>
        </template>
      </table>

      <div
        v-if="
          orderNumber === 1 ||
            orderNumber === 3 ||
            orderNumber === 5 ||
            orderNumber === 7 ||
            orderNumber === 8 ||
            uniCategoryRating.criteria.length < 4 ||
            (uniCategoryRating.criteria.length < 12 &&
              uniCategoryRating.criteria.length >= 7)
        "
        class="text-center"
      >
        <img
          class="last-page-picture"
          :class="[
            {
              'last-page-picture-small': orderNumber === 1
            },
            {
              'last-page-picture-medium': orderNumber === 7
            }
          ]"
          :src="`img/imgPdf/${getCategoryPicture(orderNumber)}`"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriterionRating",
  props: {
    orderNumber: {
      type: Number
    },
    uniCategoryRating: {
      type: Object
    },
    universityInfo: {
      type: Object
    }
  },
  methods: {
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    },
    getCategoryPicture(orderNumber) {
      return `category${orderNumber}.png`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
